/* Riportato SelectionSchemaExtender di volto-form-block più le personalizzazioni di ausl romagna */

import { defineMessages } from 'react-intl';
import { SelectionSchemaExtender as SSE } from 'volto-form-block/components/FieldTypeSchemaExtenders';

const messages = defineMessages({
  field_custom_notification_email: {
    id: 'form_field_custom_notification_email',
    defaultMessage: 'Notifiche custom',
  },
  field_custom_notification_email_helptext: {
    id: 'form_field_custom_notification_email_helptext',
    defaultMessage:
      "È possibile creare coppie di valori separati da simbolo '|' per aggiungere un destinatario diverso in base al valore della form selezionato, es. 'Valore|email.test@gmail.com', andare a capo dopo ogni coppia di valore.",
  },
});

export const SelectionSchemaExtender = (intl) => {
  let schema_extender = SSE(intl);
  schema_extender.fields.push('custom_notification_email');
  schema_extender.properties.custom_notification_email = {
    title: intl.formatMessage(messages.field_custom_notification_email),
    widget: 'textarea',
    description: intl.formatMessage(
      messages.field_custom_notification_email_helptext,
    ),
  };
  return schema_extender;
};
